import { defineFcm } from '../shared/factory';

export const FCM_STARFISH_HOMEPAGE_V2 = defineFcm('starfish_homepage_v2')
	.asBoolean()
	.withDefault(false)
	.withMerger(({ localeValue, countryValue }) => localeValue && countryValue)
	.toConfig();
